import { useQuery } from '@apollo/client';
import { FC } from 'react';
import { lookupCountryQuery } from './country-query';
import { Country } from '../../../types/country';
import { Descriptions } from 'antd';

interface CountryViewProps {
  countryCode: string;
  label?: string;
  title?: string | React.ReactNode;
  layout?: 'vertical' | 'horizontal';
  extra?: React.ReactNode;
}
export const CountryView: FC<CountryViewProps> = (props) => {
  const { data: countryData } = useQuery(lookupCountryQuery, {
    context: { clientName: 'unauthorized' }
  });
  const getCountryName = (countryCode: string) => {
    const country = countryData?.countries?.eventPayload?.countries.find((item: Country) => item.countryCode === countryCode);
    return country ? country.countryName : null;
  };
  return (
    <Descriptions title={props.title} layout={props.layout} labelStyle={{ fontSize: '12px' }} extra={props.extra}>
      <Descriptions.Item label={props.label ?? 'Country'}>{getCountryName(props.countryCode)}</Descriptions.Item>
    </Descriptions>
  );
};
